"use strict";

module.exports = function (column, e) {
  /*This event does not work*/
  console.log('drop:' + column);

  //e.preventDefault()
  var data = e.dataTransfer.getData("text");
  console.log(data);
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/drop-column.js